export const ICON_TYPES = {
	ionicon: 'ionicon',
	fontAwesome5: 'fontAwesome5',
	fontisto: 'fontisto',
	materialIcons: 'materialIcons',
	materialCommunityIcons: 'materialCommunityIcons',
	fontAwesome: 'fontAwesome',
};
